module.exports = __webpack_public_path__ + "img/hr-rock-big-08.ecda8649.png";